module.exports = __webpack_public_path__ + "static/media/bg-sc.d624df24.jpg";